import { render, staticRenderFns } from "./report.vue?vue&type=template&id=22073918"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=22073918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports